/** Decisioni pure sul turno vocale: quando riprendere dopo un annuncio e quali chiamate eseguire. */

const ANNOUNCEMENT = /\b(controllo|controlliamo|controllare|verifico|verifichiamo|verificare|eseguo|eseguiamo|eseguire|procedo|procediamo|procedere|recupero|recuperiamo|cerco|cerchiamo|cercare|ricerco|ricerca|guardo|guardiamo|apro|apriamo|aggiorno|salvo|salviamo|invio|inserisco|inseriamo|inserire|registro|registriamo|registrare|misuro|misuriamo|misurare|un attimo|un secondo|un momento|provo a|vediamo|vedo se|sto cercando|sto controllando|sto verificando|sto eseguendo|sto registrando|sto inserendo|sto per)\b/i;

export function shouldNudgeAnnouncement(transcript) {
  const text = String(transcript || "").replace(/\s+/g, " ").trim();
  if (text.length < 8 || text.length > 240) return false;
  if (text.includes("?")) return false;
  if (/\b(conferm\w*|annull\w*|scus\w*)\b/i.test(text)) return false;
  return ANNOUNCEMENT.test(text.slice(0, 80));
}

export function transcriptFromResponse(response) {
  const parts = [];
  for (const item of response?.output || []) {
    for (const part of item?.content || []) {
      const transcript = typeof part?.transcript === "string" ? part.transcript.trim() : "";
      if (transcript) parts.push(transcript);
    }
  }
  return parts.join(" ").trim();
}

function rememberCall(byId, item) {
  if (!item?.call_id || !item?.name) return;
  if (item.type && item.type !== "function_call") return;
  const args = typeof item.arguments === "string" ? item.arguments : "";
  if (!args.trim()) return;
  const prev = byId.get(item.call_id);
  if (prev && prev.arguments.length > args.length) return;
  byId.set(item.call_id, {
    type: "function_call",
    call_id: item.call_id,
    name: item.name,
    arguments: args,
    status: "completed",
  });
}

/** Unisce le chiamate arrivate in streaming con quelle nel response.done. Tiene gli argomenti più completi. */
export function mergeFunctionCalls(output, streamed) {
  const byId = new Map();
  for (const item of streamed || []) rememberCall(byId, item);
  for (const item of output || []) {
    if (item?.type === "function_call") rememberCall(byId, item);
  }
  return [...byId.values()];
}

/**
 * Interruzione vera dell'utente, non l'eco della voce di EVA.
 * Un parlato breve che si sovrappone all'assistente non conta.
 */
export function isRealUserInterrupt(status, { overlappedAssistant = false, speechMs = 0 } = {}) {
  if (status !== "cancelled") return false;
  if (overlappedAssistant) return speechMs >= 1000;
  return speechMs > 400;
}
